const StatDisplay = ({ label, value }) => {
  return (
    <div
      key={label}
      className="flex-1 bg-secondary-600/5 border border-secondary-600 rounded-md p-4 flex flex-col items-center justify-center gap-2"
    >
      <span className="text-3xl font-bold">{value || 0}</span>
      <span className="text-md">{label}</span>
    </div>
  )
}

export default StatDisplay
